import axios from 'axios';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import Form from 'react-bootstrap/esm/Form';
import { withTranslation } from 'react-i18next';

import { getMyAccountData } from '../actions/account';
import { getMyMapOverlays } from '../actions/map_overlays';
import { getAllMoorings, getBoundsForMarina } from '../actions/moorings';
import QRIcon from '../assets/icons/bp_qr_symbol.png';
import ConsentWall from '../components/ConsentWall';
import FormInput from '../components/FormInput';
// import MyMapComponent from '../components/MooringsMap'
import { MooringsMap } from '../components/MooringsMap';
import COLORS from '../constants/colors';

const i18nPrefix = 'FindMoorings';

const FILTER_DEFAULTS = {
  showUnavailable: true,
  showPois: false,
  showExcludingMarinaFee: true,
  showBouyPlaces: true,
  length_low: 0,
  length_high: 25,
  beam_low: 0,
  beam_high: 10,
  draft_low: 0,
  draft_high: 10,
  draft_deviation: 0,
  boat_types: [],
};

const Cursor = () => {
  var [position, setPosition] = useState({ x: 0, y: 0 });

  position.x -= 10;
  position.y -= 38;

  useEffect(() => {
    document.addEventListener('mousemove', onMouseMove);

    return () => {
      document.removeEventListener('mousemove', onMouseMove);
    };
  }, []);

  const onMouseMove = (e) => {
    setPosition({ x: e.clientX, y: e.clientY });
  };
  return (
    <div>
      <img
        className='cursor'
        style={{ left: `${position.x}px`, top: `${position.y}px` }}
        src={
          'https://mt.googleapis.com/vt/icon/name=icons/spotlight/spotlight-poi.png&scale=1'
        }
      />
    </div>
  );
};

class FindMoorings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      success: false,
      error: false,
      allMoorings: false,
      filteredMoorings: false,
      clusters: false,
      add_mooring: false,
      change_mooring_position: false,
      center: [5, 6],
      bounds: null,
      filter: {
        show_permanent_moorings: false,
        show_foreign_moorings: true,
        show_map_overlays: false,
        show_berth_numbers: true,
      },
      map_overlays: [],
      googleMapsCookiesAccepted: false,
    };

    this.geocoder = null;
    this.countryBoundsCache = {};
    this.mooringSearchCancelSource = null;
  }

  componentDidMount() {
    this.props.onRef(this);
    document.addEventListener('keydown', this.keyDown, false);

    this.fetchMapBounds(
      (initialBounds) => {
        this.setState({ bounds: initialBounds });
        this.refreshMoorings(initialBounds);
      },
      () => {},
    );
    getMyMapOverlays(
      (map_overlays) => {
        this.setState({ map_overlays: map_overlays });
      },
      () => {},
    );

    this.setState({
      filter: {
        show_permanent_moorings: JSON.parse(
          localStorage.getItem('show_permanent_moorings'),
        ),
        show_foreign_moorings: JSON.parse(
          localStorage.getItem('show_foreign_moorings'),
        ),
        show_map_overlays: JSON.parse(
          localStorage.getItem('show_map_overlays'),
        ),
        show_berth_numbers: JSON.parse(
          localStorage.getItem('show_berth_numbers'),
        ),
      },
    });
  }

  refreshMoorings = (bounds = this.state.bounds) => {
    const filter = {
      ...FILTER_DEFAULTS,
      marina_id: this.state.filter.show_foreign_moorings
        ? null
        : this.props.account_data.account_id,
    };
    if (this.mooringSearchCancelSource) {
      this.mooringSearchCancelSource.cancel();
    }
    this.mooringSearchCancelSource = axios.CancelToken.source();
    getAllMoorings(
      this.props.from_date,
      this.props.to_date,
      bounds,
      filter,
      this.getAllMooringsSuccess,
      this.getAllMooringsError,
      this.mooringSearchCancelSource.token,
    );
  };

  handleMapBoundsChange = (bounds) => {
    this.setState({ bounds });
    this.refreshMoorings(bounds);
  };

  ensureGeocoder = () => {
    if (this.geocoder) {
      return this.geocoder;
    }
    if (window.google?.maps?.Geocoder) {
      this.geocoder = new window.google.maps.Geocoder();
      return this.geocoder;
    }
    return null;
  };

  normalizeBoundsResponse = (boundsData) =>
    new Promise((resolve, reject) => {
      if (!boundsData) {
        reject(new Error('No bounds data'));
        return;
      }

      const minLat = Number(boundsData.min_lat);
      const maxLat = Number(boundsData.max_lat);
      const minLng = Number(boundsData.min_lng);
      const maxLng = Number(boundsData.max_lng);
      const numericBounds = {
        min_lat: minLat,
        max_lat: maxLat,
        min_lng: minLng,
        max_lng: maxLng,
      };
      const hasValidBounds = Object.values(numericBounds).every((value) =>
        Number.isFinite(value),
      );

      const countryCodeRaw =
        typeof boundsData.country === 'string'
          ? boundsData.country
          : typeof boundsData.country_code === 'string'
            ? boundsData.country_code
            : '';
      const countryCode = countryCodeRaw.trim().toUpperCase();

      const resolveWithCountry = () => {
        const cachedBounds = this.countryBoundsCache[countryCode];
        if (cachedBounds) {
          resolve(cachedBounds);
          return;
        }

        const geocoder = this.ensureGeocoder();
        if (!geocoder) {
          if (hasValidBounds) {
            resolve(numericBounds);
            return;
          }
          reject(new Error('Geocoder is not available'));
          return;
        }

        geocoder.geocode({ address: countryCode }, (results, status) => {
          if (
            status === 'OK' &&
            Array.isArray(results) &&
            results.length > 0 &&
            results[0]?.geometry
          ) {
            const geometryBounds =
              results[0].geometry.bounds || results[0].geometry.viewport;
            if (geometryBounds) {
              const northEast = geometryBounds.getNorthEast();
              const southWest = geometryBounds.getSouthWest();
              const normalizedBounds = {
                min_lat: southWest.lat(),
                min_lng: southWest.lng(),
                max_lat: northEast.lat(),
                max_lng: northEast.lng(),
              };
              this.countryBoundsCache[countryCode] = normalizedBounds;
              resolve(normalizedBounds);
              return;
            }
          }

          if (hasValidBounds) {
            resolve(numericBounds);
            return;
          }

          reject(new Error(`Failed to resolve bounds for country (${status})`));
        });
      };

      if (countryCode) {
        resolveWithCountry();
        return;
      }

      if (hasValidBounds) {
        resolve(numericBounds);
        return;
      }

      reject(new Error('No bounds or country information provided'));
    });

  fetchMapBounds = (onSuccess, onError) => {
    const handleSuccess = (rawBounds) => {
      this.normalizeBoundsResponse(rawBounds)
        .then((normalizedBounds) => {
          if (normalizedBounds) {
            if (typeof onSuccess === 'function') {
              onSuccess(normalizedBounds);
            }
          } else if (typeof onError === 'function') {
            onError(new Error('Unable to normalize bounds'));
          }
        })
        .catch((error) => {
          console.error('Failed to prepare map bounds', error);
          if (typeof onError === 'function') {
            onError(error);
          }
        });
    };

    const handleError = (error) => {
      if (typeof onError === 'function') {
        onError(error);
      }
    };

    getBoundsForMarina(handleSuccess, handleError);
  };

  componentWillUnmount() {
    document.removeEventListener('keydown', this.keyDown, false);
    this.props.onRef(undefined);
    if (this.mooringSearchCancelSource) {
      this.mooringSearchCancelSource.cancel();
    }
  }

  keyDown = (event) => {
    //If escape is pressed to the same as right click
    if (event.keyCode === 27) {
      this.onMapRightClick();
    }
  };

  getAllMooringsSuccess = (moorings) => {
    console.log('getAppmoorings success', moorings);
    this.filterMoorings(moorings.markers);
    this.setState({ clusters: moorings.clusters });
  };

  getAllMooringsError = (response) => {
    this.setState({
      loading: false,
      success: false,
      error: 'something went wrong',
    });
  };

  reloadMap = () => {
    console.log('this.state.bounds', this.state.bounds);
    this.refreshMoorings();
    this.props.onReloadPress();
  };

  onMapClick = (e) => {
    if (this.state.add_mooring) {
      this.setState({ add_mooring: false });
      const position = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng(),
      };
      this.props.addMooring(position);
    } else if (this.state.change_mooring_position) {
      this.setState({ change_mooring_position: false });
      const position = {
        latitude: e.latLng.lat(),
        longitude: e.latLng.lng(),
      };
      this.props.changeMooringPosition(position);
    } else {
      this.props.onMapClick();
    }
  };

  onMapRightClick = () => {
    // Dismiss add_mooring or change_mooring action
    this.setState({
      add_mooring: false,
      change_mooring_position: false,
    });
    this.reloadMap();
  };

  addMooringPressed = () => {
    this.setState({ add_mooring: true });
  };

  filterMoorings = (moorings) => {
    var filteredMoorings = moorings || [];

    if (!this.state.filter.show_permanent_moorings) {
      filteredMoorings = filteredMoorings.filter(
        (mooring) => mooring.app_visible == 1,
      );
    }

    this.setState({ filteredMoorings: filteredMoorings });
  };

  annimateToCoordinates = (lat, lon) => {
    this.setState({ center: [lat, lon] });
  };

  changeMooringPositionClicked = (mooring_id) => {
    var filteredMoorings = this.state.filteredMoorings.filter(
      function (mooring) {
        return mooring.mooring_id != mooring_id;
      },
    );

    this.setState({
      change_mooring_position: true,
      filteredMoorings: filteredMoorings,
    });
  };
  changeMooringPosition = (updated_mooring) => {
    const filteredMoorings =
      this.state.filteredMoorings.concat(updated_mooring);
    this.setState({
      filteredMoorings: filteredMoorings,
    });
  };

  openQRCode = async (event) => {
    event.preventDefault();
    const getAccountId = async () => {
      if (!this.props.account_data.account_id) {
        return new Promise((resolve) => {
          getMyAccountData(
            (account_data) => resolve(account_data.account_id),
            (error) => resolve(null),
          );
        });
      }
      return this.props.account_data.account_id;
    };
    const account_id = await getAccountId();
    if (!account_id) {
      console.error('Failed to get account id for QR code');
      return;
    }
    const bpms_link = encodeURIComponent(
      `${process.env.REACT_APP_MS_LINK}${account_id}`,
    );
    const QRLink = `https://api.qrserver.com/v1/create-qr-code/?size=512x512&data=${bpms_link}`;
    window.open(QRLink, '_blank');
  };

  render() {
    const { t } = this.props;
    const allMoorings = this.state.allMoorings;
    const filteredMoorings = this.state.filteredMoorings;
    const clusters = this.state.clusters;
    var fdfdf = new Date(this.props.from_date);
    const filter = this.state.filter;
    var to_date_min = new Date();
    to_date_min.setDate(fdfdf.getDate() + 1);

    const role = localStorage.getItem('role');
    const management = role == 'management';
    const private_role = role == 'private';
    const right_add_mooring = this.props.account_data.rights?.create_mooring;
    const show_add_mooring_button = !private_role && right_add_mooring;
    console.log(this.props.account_data.rights?.create_mooring);

    const supervised_by_management =
      !!this.props.account_data.supervising_management;
    const option_show_permanent_moorings = true; //management || supervised_by_management;
    const option_show_marina_plan = this.state.map_overlays.length != 0;

    return (
      <div
        onContextMenu={(e) => this.onMapRightClick(e)}
        style={{ width: '100%', height: '100%' }}>
        {this.state.add_mooring && <Cursor />}
        {this.state.change_mooring_position && <Cursor />}
        <div
          style={{
            marginBottom: 10,
            padding: 5,
            backgroundColor: 'white',
            borderRadius: 5,
          }}>
          <Row>
            <Col md={3}>
              <FormInput
                id='input_from_date_home'
                label={t(`global.from`)}
                type='date'
                required
                value={moment(this.props.from_date).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const date = moment(e.target.value).format('YYYY-MM-DD');
                  this.props.onFromDateChange(date);
                  this.setState({ from_date: date }, () => {
                    this.reloadMap();
                  });
                }}
              />
            </Col>

            <Col md={3}>
              <FormInput
                id='input_to_date_home'
                label={t(`global.to`)}
                type='date'
                required
                value={moment(this.props.to_date).format('YYYY-MM-DD')}
                onChange={(e) => {
                  const date = moment(e.target.value).format('YYYY-MM-DD');
                  this.props.onToDateChange(date);
                  this.setState({ to_date: date }, () => {
                    this.reloadMap();
                  });
                }}
              />
            </Col>

            <Col xs={10} md={5} style={{ marginTop: 15 }}>
              {show_add_mooring_button && (
                <Button
                  id='button_add_mooring'
                  style={{ ...styles.button }}
                  onClick={this.addMooringPressed}>
                  {t('MaintainMoorings.addNewMooring')}
                </Button>
              )}
            </Col>

            <Col xs={1} md={1} style={{ marginTop: 15 }}>
              <a
                href=''
                target='_blank'
                rel='noreferrer'
                onClick={this.openQRCode}>
                <img
                  style={{ width: 28, marginTop: 6 }}
                  src={QRIcon}
                  alt='tableicon'
                />
              </a>
            </Col>
            {/* <Col>
              <Button style={styles.button} onClick={() => this.reloadMap()}>Reload</Button>
              </Col> */}
          </Row>
        </div>

        <div
          style={{
            marginBottom: 10,
            padding: 5,
            backgroundColor: 'white',
            borderRadius: 5,
          }}>
          <Row>
            {option_show_permanent_moorings && (
              <Col>
                <Form.Check
                  id='show_permanent_moorings'
                  type='checkbox'
                  label={t(`${i18nPrefix}.showRentedMoorings`)}
                  checked={this.state.filter.show_permanent_moorings}
                  onChange={(event) => {
                    this.setState({
                      filter: {
                        ...filter,
                        show_permanent_moorings: event.target.checked,
                      },
                    });
                    localStorage.setItem(
                      'show_permanent_moorings',
                      JSON.stringify(event.target.checked),
                    );
                    this.reloadMap();
                  }}
                />
              </Col>
            )}
            {option_show_marina_plan && (
              <Col>
                <Form.Check
                  id='show_map_overlays'
                  type='checkbox'
                  label={t(`${i18nPrefix}.showMarinaMap`)}
                  checked={this.state.filter.show_map_overlays}
                  onChange={(event) => {
                    this.setState({
                      filter: {
                        ...filter,
                        show_map_overlays: event.target.checked,
                      },
                    });
                    localStorage.setItem(
                      'show_map_overlays',
                      JSON.stringify(event.target.checked),
                    );
                    this.reloadMap();
                  }}
                />
              </Col>
            )}
            <Col>
              <Form.Check
                id='show_berth_numbers'
                type='checkbox'
                label={t(`${i18nPrefix}.showBerthNumbers`)}
                checked={this.state.filter.show_berth_numbers}
                onChange={(event) => {
                  this.setState({
                    filter: {
                      ...filter,
                      show_berth_numbers: event.target.checked,
                    },
                  });
                  localStorage.setItem(
                    'show_berth_numbers',
                    JSON.stringify(event.target.checked),
                  );
                  this.reloadMap();
                }}
              />
            </Col>
            <Col>
              <Form.Check
                id='show_berth_numbers'
                type='checkbox'
                label={t(`${i18nPrefix}.showForeignMoorings`)}
                checked={this.state.filter.show_foreign_moorings}
                onChange={(event) => {
                  this.setState(
                    {
                      filter: {
                        ...filter,
                        show_foreign_moorings: event.target.checked,
                      },
                    },
                    () => {
                      this.reloadMap();
                    },
                  );
                  localStorage.setItem(
                    'show_foreign_moorings',
                    JSON.stringify(event.target.checked),
                  );
                  this.reloadMap();
                }}
              />
            </Col>
          </Row>
        </div>

        {!this.state.googleMapsCookiesAccepted ? (
          <ConsentWall
            onAccept={(permanent) =>
              this.setState({ googleMapsCookiesAccepted: true })
            }
          />
        ) : (
          <MooringsMap
            allMoorings={this.state.filteredMoorings || []}
            clusters={clusters}
            onPinClick={this.props.onPinClick}
            onClick={(e) => this.onMapClick(e)}
            add_mooring_position={this.props.add_mooring_position}
            filter={this.state.filter}
            map_overlays={this.state.map_overlays}
            fetchBoundsForMarina={this.fetchMapBounds}
            setBounds={this.handleMapBoundsChange}
          />
        )}
      </div>
    );
  }
}

const styles = {
  button: {
    backgroundColor: 'white',
    color: COLORS.MAIN_GRAY,
    fontWeight: 'bold',
    borderColor: COLORS.MAIN_GRAY,
    marginRight: 10,
    marginTop: 5,
    marginBottom: 5,
  },
};

export default withTranslation()(FindMoorings);
